import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer
            className="bg-ink text-paper2 px-5 lg:px-12 xl:px-16 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3"
            data-testid="footer"
        >
            <Link
                to="/"
                data-testid="footer-wordmark"
                className="mono font-bold text-paper"
            >
                _beingdevang<span className="blink text-sage">_</span>
            </Link>
            <p className="mono text-[10px] tracking-[0.2em] text-paper2/50">
                © 2025. ALL RIGHTS RESERVED.
            </p>
        </footer>
    );
}
